export default "__VITE_ASSET__Ci3dvy49__"